import { ColumnsType } from "antd/es/table";
import { Space, Dropdown } from "antd";
import ColumnSearch from "./ColumnSearch"; // Seu componente de busca
import { BotoesAcoes } from "../styles"; // Botões de ação
import SettingsIcon from "@mui/icons-material/Settings";
import { getMenuItems } from "../constants/itemsActionColumns";

export const Columns = (
  onClick: (e: any) => void,
  setCotaId: (e: any) => void,
  setNumeroCota: (e: any) => void,
  filteredInfo: {
    numeroCota?: string[] | null;
    origem?: string[] | null;
  }
): ColumnsType<any> => {
  const items = getMenuItems();

  return [
    {
      title: "Número da Cota",
      dataIndex: "numeroCota",
      key: "numeroCota",
      width: "30%",
      filteredValue: filteredInfo.numeroCota || null, // Aplicar os valores do estado
      onFilter: (value, record) => record.numeroCota.includes(value),
      ...ColumnSearch<any>({ dataIndex: "numeroCota" }),
    },

    {
      title: "Origem",
      dataIndex: "origem",
      key: "origem",
      width: "30%",
      filters: [
        { text: "Multicotas", value: "Multicotas" },
        { text: "Usuário", value: "Usuário" },
      ],
      filteredValue: filteredInfo.origem || null,
      onFilter: (value, record) => record.origem.includes(value),
      filterSearch: true,
    },
    {
      title: "Cotas Usuários",
      dataIndex: "cotasUsuarios",
      key: "cotasUsuarios",
      width: "20%",
      render: (value) => value ?? 0,
    },

    {
      title: "Ações",
      dataIndex: "operation",
      key: "operation",
      width: "10%",
      align: "center",
      filteredValue: null,
      render: (item, row) => (
        <Space size="middle">
          <Dropdown menu={{ items, onClick }} trigger={["click"]}>
            <BotoesAcoes
              onClick={() => {
                setCotaId(row.key);
                setNumeroCota(row.numeroCota);
              }}
            >
              <Space>
                <SettingsIcon />
              </Space>
            </BotoesAcoes>
          </Dropdown>
        </Space>
      ),
    },
  ];
};
